import {
    useNavigate
} from "react-router-dom";

export const Router = () => {
    const route = useNavigate()

    return {
        route
    }
}